import { DayOfWeek, RecurrenceFrequency } from 'generated/types'

const numToDayMap = {
  '2': DayOfWeek.Mon,
  '3': DayOfWeek.Tue,
  '4': DayOfWeek.Wed,
  '5': DayOfWeek.Thu,
  '6': DayOfWeek.Fri,
}

export const getRecurrenceRule = frequencyValue => {
  const frequencyMap = {
    weekly: RecurrenceFrequency.Weekly,
    everyOtherWeek: RecurrenceFrequency.Weekly,
    monthly: RecurrenceFrequency.Monthly,
  }

  const frequency = frequencyMap[frequencyValue.frequency]
  const byWeekDay =
    frequency === RecurrenceFrequency.Weekly ? [numToDayMap[frequencyValue.day]] : null
  let byMonthDay = null

  if (frequency === RecurrenceFrequency.Monthly) {
    /**
     * Passing `-2` means you want the frequency to be 1st and 15th of the month
     */
    if (frequencyValue.day === '-2') {
      byMonthDay = [1, 15]
    } else {
      byMonthDay = [parseInt(frequencyValue.day, 10)]
    }
  }

  return {
    frequency,
    byWeekDay,
    byMonthDay,
    interval: frequencyValue.interval,
  }
}

export const getDayOfWeek = () => {
  const day = new Date().getDay()
  // if the user is submitting the transfer request on friday or the weekend
  // it will get processed on monday
  if (day === 0 || day === 6) {
    return 2
  }
  return day + 1
}

export const getNextRecurringDate = (today: Date, frequency: string) => {
  const nextDate = new Date(today)
  const todayDayOfWeek = today.getDay()
  const todayDate = today.getDate()
  // Saturday is 2, Sunday is 1, weeekday is 0
  const addDays = todayDayOfWeek === 6 ? 2 : todayDayOfWeek === 0 ? 1 : 0

  if (frequency === 'weekly') {
    nextDate.setDate(todayDate + addDays)
  }
  return nextDate
}
